import React from 'react';
import { motion } from 'framer-motion';
import { MapIcon, UserSearchIcon, LayoutDashboardIcon, VideoIcon, MessageCircleIcon } from 'lucide-react';
const steps = [{
  day: 'DÍA 1',
  action: 'Identificas exactamente a quién quieres atraer. Nunca más le hablarás a "todo el mundo"',
  result: 'Tienes la imagen clara de tu prospecto ideal',
  icon: UserSearchIcon
}, {
  day: 'DÍAS 2-3',
  action: 'Optimizas tu bio, tu foto y tu feed para que sean una vitrina profesional de liderazgo',
  result: 'Tu perfil convierte visitantes en seguidores interesados',
  icon: LayoutDashboardIcon
}, {
  day: 'DÍAS 4-5',
  action: 'Grabas tus primeros Reels con la fórmula de gancho específica para Networkers',
  result: 'Tu contenido empieza a circular entre personas que no te conocen',
  icon: VideoIcon
}, {
  day: 'DÍAS 6-7',
  action: 'Activas el sistema de Historias con preguntas filtro y usas los guiones de cierre magnético',
  result: 'Tu primera conversación entra sola. Tú no buscaste a nadie',
  icon: MessageCircleIcon
}];
export function Roadmap() {
  return <section className="bg-brand-dark px-6 py-20 md:py-28 border-y border-slate-800" data-id="element-223">
      <div className="mx-auto max-w-6xl" data-id="element-224">
        <div className="text-center mb-14" data-id="element-225">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-226">
            <span className="inline-block text-brand-gold font-bold uppercase tracking-widest text-sm mb-3" data-id="element-227">
              ¿Cómo Funciona?
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white" data-id="element-228">
              Tu Ruta de 7 Días:{' '}
              <span className="text-brand-gold" data-id="element-229">
                Simple, Clara y Ejecutable
              </span>
            </h2>
          </motion.div>
        </div>

        {/* Mobile hint */}
        <p className="text-slate-500 text-sm text-center mb-6 md:hidden" data-id="element-230">
          ← Desliza para ver la tabla completa →
        </p>

        {/* Table wrapper */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="overflow-x-auto rounded-2xl border border-slate-800" data-id="element-231">
          <table className="w-full min-w-[640px] text-left" data-id="element-232">
            <thead data-id="element-233">
              <tr className="bg-brand-darker border-b border-slate-700" data-id="element-234">
                <th className="px-6 py-4 text-brand-gold font-bold uppercase tracking-wider text-xs w-[140px]" data-id="element-235">
                  Paso
                </th>
                <th className="px-6 py-4 text-brand-gold font-bold uppercase tracking-wider text-xs" data-id="element-236">
                  Lo que pasa
                </th>
                <th className="px-6 py-4 text-brand-gold font-bold uppercase tracking-wider text-xs" data-id="element-237">
                  Resultado
                </th>
              </tr>
            </thead>
            <tbody data-id="element-238">
              {steps.map((step, index) => {
              const Icon = step.icon;
              return <motion.tr key={step.day} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1
              }} className="border-b border-slate-800 last:border-b-0 bg-brand-light hover:bg-brand-lighter/50 transition-colors" data-id="element-239">
                    <td className="px-6 py-5" data-id="element-240">
                      <div className="flex items-center gap-3" data-id="element-241">
                        <div className="w-9 h-9 rounded-lg bg-brand-gold/10 flex items-center justify-center shrink-0" data-id="element-242">
                          <Icon className="w-4 h-4 text-brand-gold" data-id="element-243" />
                        </div>
                        <span className="text-white font-bold text-sm whitespace-nowrap" data-id="element-244">
                          {step.day}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-5 text-slate-300 text-sm leading-relaxed" data-id="element-245">
                      {step.action}
                    </td>
                    <td className="px-6 py-5 text-green-400 font-medium text-sm leading-relaxed" data-id="element-246">
                      {step.result}
                    </td>
                  </motion.tr>;
            })}
            </tbody>
          </table>
        </motion.div>

        {/* Closing phrase */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="text-center mt-12 text-lg md:text-xl text-slate-300 italic max-w-3xl mx-auto" data-id="element-247">
          "Después del Día 7 nunca más dirás:{' '}
          <span className="text-brand-gold font-semibold not-italic" data-id="element-248">
            'No tengo a quién invitar al Zoom esta noche.'
          </span>
          "
        </motion.p>
      </div>
    </section>;
}